import { useEffect } from 'react';

const RedirectDogView = () => {
  useEffect(() => {
    window.location.href = 'https://www.petson.se/hundforsakring/teckna';
  }, []);

  return null;
};

export default RedirectDogView;
